import React from "react";

function SectionHead({ leadFirstLabel, leadSecondLabel, trailingFirstLabel, trailingSecondLabel, onViewPress }) {
    
    return (
        <div className="px-2">
            <div className="d-flex justify-content-between">
                <SectionHeadItem onClick={() => { }} firstLabel={leadFirstLabel} secondLabel={leadSecondLabel} clsName={"section-lead"} />
                <SectionHeadItem onClick={onViewPress} firstLabel={trailingFirstLabel} secondLabel={trailingSecondLabel} clsName={"section-trail cursor-pointer"} />
            </div>
            <hr style={{ color: "#a8a8a850" }} />
        </div>
    );
}
export default SectionHead;


function SectionHeadItem({ firstLabel, secondLabel, clsName, onClick }) {
    return (
        <div className="position-relative d-flex" onClick={onClick}>
            <p className={`my-auto ${clsName}`} style={{
                fontFamily: "Poppins",
                fontWeight: 500,
                textAlign: "left",
                color: "#000",
            }}>{firstLabel}{" "}<span style={{ color: "#ec008c" }}>{secondLabel}</span></p>
            <div style={{ height: "10%", width: "20%", background: "#000", position: "absolute", bottom: 0, right: 0 }}></div>
        </div>
    );
}